import EmitenteRestricaoPadraoService from "@/services/EmitenteRestricaoPadraoService";

export const emitenteRestricaoPadrao = {
  namespaced: true,
  state: {
    emitenteRestricaoPadrao: {},
  },
  actions: {
    getEmitenteRestricaoPadrao({ commit }, payload) {
      return EmitenteRestricaoPadraoService.GetEmitenteRestricaoPadrao(
        payload
      ).then(
        (emitenteRestricaoPadrao) => {
          return Promise.resolve(emitenteRestricaoPadrao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEmitenteRestricaoPadrao({ commit }, payload) {
      return EmitenteRestricaoPadraoService.PostEmitenteRestricaoPadrao(
        payload
      ).then(
        (emitenteRestricaoPadrao) => {
          return Promise.resolve(emitenteRestricaoPadrao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEmitenteRestricaoPadrao({ commit }, payload) {
      return EmitenteRestricaoPadraoService.PutEmitenteRestricaoPadrao(
        payload
      ).then(
        (emitenteRestricaoPadrao) => {
          return Promise.resolve(emitenteRestricaoPadrao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEmitenteRestricaoPadrao({ commit }, payload) {
      return EmitenteRestricaoPadraoService.DeleteEmitenteRestricaoPadrao(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEmitenteRestricaoPadraoOData({ commit }, payload) {
      return EmitenteRestricaoPadraoService.GetEmitenteRestricaoPadraoOData(
        payload
      ).then(
        (emitenteRestricaoPadrao) => {
          return Promise.resolve(emitenteRestricaoPadrao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default emitenteRestricaoPadrao;
